import { NavigatorActions, NavigatorActionTypes } from './navigator.actions';


export interface NavigatorState {
	actualBsRes: string,	// Actual Boostrap Resolution
	prevBsRes: string		// Previous Boostrap Resolution
}

export const initialNavigatorState: NavigatorState = {
	actualBsRes: null,
	prevBsRes: null
}

export function navigatorReducer( state: NavigatorState = initialNavigatorState, action: NavigatorActions ): NavigatorState {
	switch( action.type ) {
		case NavigatorActionTypes.NavigatorBsResChanged:
			let actualBsRes: string = action["payload"]["bsRes"];
			return { ...state, prevBsRes: state.actualBsRes, actualBsRes };
		default:
			return state;
	}
}